import { IKeHoachNamActionTypes } from "../../action-types/category/IKeHoachNamActions";
import { IKeHoachNamReducer } from "../../reducer-model/category/IKeHoachNamReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IKeHoachNamReducer = {
  status: eReducerStatusBase.is_not_initialization,
  keHoachNams: [],
};
export const keHoachNamReducer = (
  state: IKeHoachNamReducer = iniState,
  action: IKeHoachNamActionTypes
): IKeHoachNamReducer => {
  switch (action.type) {
    case "KE_HOACH_NAM_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KE_HOACH_NAM_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachNams: action.payload,
      };
    case "KE_HOACH_NAM_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };

    default:
      return state;
  }
};
